import React, { useEffect } from "react";
import NProgress from "nprogress";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./progress.module.scss";

export const Progress: React.FC = () => {
  useEffect(() => {
    NProgress.start();
    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div className={styles.ProgressContainer}>
      <div className={styles.LoaderWrapper}>
        <CircularProgress size={44} thickness={4} style={{ color: "#2563eb" }} />
        <span className={styles.LoadingText}>Loading page...</span>
      </div>
    </div>
  );
};

